// src/firebase1.ts (Oyun 1)
import { initializeApp } from "firebase/app";
import { getFirestore } from "firebase/firestore";

const firebaseConfig = {
    apiKey: "AIzaSyDKZXpPXGsZUrjiZmOJTlG7X5gtvlZ9ePM",
    authDomain: "pawzle.firebaseapp.com",
    projectId: "pawzle",
    storageBucket: "pawzle.firebasestorage.app",
    messagingSenderId: "505845229967",
    appId: "1:505845229967:web:0196fff476a0f2b6b883fa",
};

const app = initializeApp(firebaseConfig, "pawzle"); // Her oyun için benzersiz bir isim
export const db3 = getFirestore(app);